import { render, staticRenderFns } from "./manager-reminder.vue?vue&type=template&id=bb9077fa&scoped=true&"
import script from "./manager-reminder.vue?vue&type=script&lang=js&"
export * from "./manager-reminder.vue?vue&type=script&lang=js&"
import style0 from "./manager-reminder.vue?vue&type=style&index=0&id=bb9077fa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9077fa",
  null
  
)

export default component.exports